"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ({ min = 0, max = 1 }) => (val) => !!(min <= val && val <= max);
//# sourceMappingURL=in-range.js.map